module.exports = __webpack_public_path__ + "static/media/xls.4818c87e.svg";